import { IPrivateLeagueAdmin } from "core-integration/src/store/leagues/types";
import { Button } from "plos/src/components/buttons/Button";
import { useState } from "react";

import { useTranslation } from "react-i18next";
import { formItem } from "../../../LeaguesAndCups/leaguesAndCups.css";
import { EntrySelector } from "../EntrySelector";
import { changeAdminWrapper, headerStyles } from "./changeAdmin.css";
interface IProps {
  updateAdmin: (entryId: number) => void;
  league: IPrivateLeagueAdmin;
}

const ChangeAdmin = ({ updateAdmin, league }: IProps) => {
  const { t } = useTranslation("leaguesAndCups");
  const [entry, setEntry] = useState<number>(0);

  const handleEntryChange = (entryId: number) => {
    setEntry(entryId);
  };

  const handleSubmit = (e: React.SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();
    updateAdmin(entry);
  };

  const disabled = !entry;

  return (
    <div className={formItem}>
      <form onSubmit={handleSubmit} className={changeAdminWrapper}>
        <h3 className={headerStyles}>
          {t("changeLeagueAdministrator", "Change League Administrator")}
        </h3>
        <EntrySelector
          handleChange={handleEntryChange}
          leagueId={league.id}
          excluded={[league.admin_entry]}
        />
        <div>
          <Button type="submit" isDisabled={disabled}>
            {t("changeAdministrator", "Change administrator")}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ChangeAdmin;
